export default __webpack_public_path__ + "static/media/upmarket-purple.a53647f6.png";